import React from 'react'
import PropTypes from 'prop-types'
import PageComponent from './PageComponent'
import ReactMarkdown from 'react-markdown'
import RegisterButton from '../CTA/RegisterButton'
import PresentationButton from '../CTA/PresentationButton'
import './InviteRow.scss'
import {GatsbyImage} from 'gatsby-plugin-image'

const InviteRow = ({backgroundColor, content, imageData, imageAlt, buttons}) => {
    return (
        <PageComponent
            backgroundColor={backgroundColor}
            style={{position: 'relative', padding: '0'}}
            containerStyle={{paddingBottom: 0}}
        >
            <div className="page__invite-row">
                <div className="page__invite-row__content">
                    <ReactMarkdown source={content} className="page__invite-row__content-text" escapeHtml={false} />
                    {renderButtons(buttons)}
                </div>
                <div className="page__invite-row__image">
                    {imageData && (
                        <GatsbyImage
                            image={imageData}
                            imgStyle={{
                                objectFit: 'cover',
                                objectPosition: '0% 50%',
                            }}
                            alt={imageAlt}
                        />
                    )}
                </div>
            </div>
        </PageComponent>
    )
}

const renderButtons = (buttons = null) => (
    <div className="buttons">
        {buttons === null ? (
            <>
                <PresentationButton />
                <RegisterButton />
            </>
        ) : (
            <>
                {!!buttons.register && <RegisterButton />}
                {!!buttons.presentation && <PresentationButton />}
            </>
        )}
    </div>
)

export default InviteRow

InviteRow.propTypes = {
    id: PropTypes.string,
    content: PropTypes.string,
    imageData: PropTypes.object,
    imageAlt: PropTypes.string,
    backgroundColor: PropTypes.string,
    buttons: PropTypes.object,
}

InviteRow.defaultProps = {
    content: '',
    integrationIds: [],
    imageData: null,
    imageAlt: '',
    backgroundColor: 'white',
    buttons: null,
}
